import React, { useState, useEffect, useRef } from "react";
import "./AI.css";
// import aiImg1 from "../../images/aiImg1.png";
// import aiImg2 from "../../images/aiImg2.png";
import chatBot from "../../Images/Icons/chatBot.png";
import aiImg3 from "../../Images/aiImg3.png";

const AI = () => {
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "Hi there! I'm Career Restorer AI. How may I assist you today?",
    },
  ]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const chatContainerRef = useRef(null);

  // Show/hide popup
  function aiChatDisplay() {
    document.getElementById("aiChatContainer").style.display = "block";
  }
  function aiChatClose() {
    document.getElementById("aiChatContainer").style.display = "none";
  }
  function aiChatFullScreenDisplay() {
    document.getElementById("aiChatFullScreen").style.display = "block";
  }
  function aiChatFullScreenClose() {
    document.getElementById("aiChatFullScreen").style.display = "none";
  }

  // Send message
  const handleSend = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setIsTyping(true);

    try {
      const res = await fetch("https://chat-bot-4-ekw7.onrender.com/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userMessage.text }),
      });

      const data = await res.json();

      setTimeout(() => {
        setIsTyping(false);
        setMessages((prev) => [
          ...prev,
          { sender: "bot", text: data.response || "No response" },
        ]);
      }, 700);
    } catch (err) {
      setIsTyping(false);
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Sorry, error connecting to the server." },
      ]);
    }
  };

  // Auto-scroll
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages, isTyping]);

  return (
    <div className="aiContainer">
      {/* Floating AI Button */}
      <div className="aiBot" onClick={aiChatDisplay}>
        <button className="chatBotIcon">
          <img src={chatBot} alt="chatBot" />
        </button>
      </div>

      {/* Chat Window */}
      <div className="aiChatContainer" id="aiChatContainer">
        <div className="aiChatSection">
          <div className="aiChatHeader">
            <p>Career Restorer Chat</p>
            <div className="aiChatHeaderBtn">
              <button
                onClick={() => {
                  aiChatFullScreenDisplay();
                  aiChatClose();
                }}
              >
                <i className="fa-solid fa-up-right-and-down-left-from-center"></i>
              </button>
              <button onClick={aiChatClose}>
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>

          {/* Messages */}
          <div className="aiChatTextarea" ref={chatContainerRef}>
            {messages.map((msg, i) => (
              <p
                key={i}
                className="aiChat"
                style={{
                  background: msg.sender === "user" ? "#3b71fe" : "#f1f1f1",
                  color: msg.sender === "user" ? "white" : "black",
                  marginLeft: msg.sender === "user" ? "auto" : "0",
                }}
              >
                {msg.text}
              </p>
            ))}

            {isTyping && (
              <p className="aiChat" style={{ background: "#f1f1f1" }}>
                Career Restorer is typing<span className="dot">.</span>
                <span className="dot">.</span>
                <span className="dot">.</span>
              </p>
            )}
          </div>

          {/* Typing Area */}
          <div className="aiChatTypingarea">
            <form onSubmit={handleSend}>
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Ask me anything..."
              />
              <button type="submit">
                <i className="fa-solid fa-paper-plane"></i>
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Fullscreen Chat */}
      <div className="aiChatFullScreen" id="aiChatFullScreen">
        <div className="aiChatFullScreenSection">
          <button onClick={aiChatFullScreenClose}>
            <i className="fa-solid fa-xmark"></i>
          </button>

          <div className="aiChatHeaderText">
            <img src={aiImg3} alt="aiImg3" />
            <p>Ask our AI anything</p>
          </div>

          {/* Messages */}
          <div className="aiChatTextarea" ref={chatContainerRef}>
            {messages.map((msg, i) => (
              <p
                key={i}
                className="aiChat"
                style={{
                  background: msg.sender === "user" ? "#3b71fe" : "#f1f1f1",
                  color: msg.sender === "user" ? "white" : "black",
                  marginLeft: msg.sender === "user" ? "auto" : "0",
                }}
              >
                {msg.text}
              </p>
            ))}

            {isTyping && (
              <p className="aiChat" style={{ background: "#f1f1f1" }}>
                Career Restorer is typing<span className="dot">.</span>
                <span className="dot">.</span>
                <span className="dot">.</span>
              </p>
            )}
          </div>

          {/* Typing Area */}
          <div className="aiChatTypingarea">
            <form onSubmit={handleSend}>
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Ask me anything..."
              />
              <button type="submit">
                <i className="fa-solid fa-paper-plane"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AI;
